import { MouseEventHandler } from 'react';
import { initiateCall } from '../util/initiateCall';
import { openGoogleMap } from '../util/openGoogleMap';
import clsx from 'clsx';

export type LinkButtonProps = {
  title: string;
  onClick?: MouseEventHandler;
  className?: string;
  phoneNumber?: string;
  googleMapAddress?: string;
  disabled?: boolean;
};

function LinkButton({
  title,
  onClick,
  className,
  phoneNumber,
  googleMapAddress,
  disabled = false,
}: LinkButtonProps) {
  const hasAction = !!(onClick || phoneNumber || googleMapAddress);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (googleMapAddress) {
      openGoogleMap(googleMapAddress);
    }

    if (phoneNumber) {
      initiateCall(phoneNumber);
    }

    if (onClick) {
      onClick(event);
    }
  };
  const baseClassName = 'm-0 border-none bg-transparent p-0 text-blue-600 hover:underline';
  const stateClassName =
    hasAction && !disabled ? 'hover:underline cursor-pointer' : 'text-gray-400 cursor-not-allowed';

  return (
    <button
      onClick={hasAction ? handleClick : undefined}
      className={clsx(baseClassName, stateClassName, className)}
      disabled={disabled || !hasAction}
    >
      {title}
    </button>
  );
}

export default LinkButton;
